import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/services';

const ServiceService = {

  deleteService( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  getServices( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  getService( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  saveService( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  updateService( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default ServiceService;



// WEBPACK FOOTER //
// ./services/ServiceService.js